import {ProfileImage} from '@/types/models/creator-crm/creatorCrm';

function getProfileImageUrl(profileImage?: ProfileImage) {
  return (
    profileImage?.image?.thumbnail ??
    profileImage?.image?.full ??
    profileImage?.image?.original ??
    profileImage?.socialPlatformsImages?.at(0) ??
    ''
  );
}

export default getProfileImageUrl;
